
import { Options, Vue }    from 'vue-class-component';
import AddonCard from '../components/shared/addon-card.vue'
import ToggleSwitch from '../components/shared/toggle-switch.vue'
import {chain, keyBy, mapValues, uniqBy} from 'lodash'

@Options({
  components: {
    AddonCard,
    ToggleSwitch
  },
  data() {
    return {
      items: this.$store.state.impregnation,
      mokriVidez: (this.$store.state.impregnation || []).filter(x => x.attributes.vrsta_impregnacije === 'Mokri videz'),
      brezbarvniVidez: (this.$store.state.impregnation || []).filter(x => x.attributes.vrsta_impregnacije === 'Brezbarvni videz'),
      title: {
        left: this.$t('Mokri videz'),
        right: this.$t('Brezbarvni videz')
      },
      isChecked: this.$store.state.impregnationSlider
    }
  },
  methods: {
    switched(value){
      this.isChecked = value;
      this.$store.commit('setImpregnationSlider',value)
    }
  },
  watch: {
    mokriVidez:{
      handler:function(newVal) {
        let impregnation = (this.$store.state.impregnation || []).concat(newVal)
        this.$store.commit('setImpregnation', uniqBy(impregnation,'key'));
      },
      deep:true
    },
    brezbarvniVidez:{
      handler:function(newVal) {
        let impregnation = (this.$store.state.impregnation || []).concat(newVal)
        this.$store.commit('setImpregnation', uniqBy(impregnation,'key'));
      },
      deep:true
    }
  }
})
export default class Impregnation extends Vue {
  items: { key: string; title: string; attributes: ({ key: string; value: string; } | { key: string; value: number; })[]; price: string; media: any; }[];
  mokriVidez: { key: string; title: string; attributes: ({ key: string; value: string; } | { key: string; value: number; })[]; price: string; media: any; }[];
  brezbarvniVidez: { key: string; title: string; attributes: ({ key: string; value: string; } | { key: string; value: number; })[]; price: string; media: any; }[];
  mounted(){
    const productRes = this.$store.state.impregnation || this.$store.state.responseImpregnation.map(x=> ({
      id: x._id,
      key: x.key,
      title: x.name,
      description: x.description,
      attributes: chain(x.propertyAttributes).keyBy('key').mapValues('value').value(),
      price: x.priceUnit ? `${(x.estimatedPrice.retailPriceWithDiscount || x.estimatedPrice.retailPrice).toFixed(2)} € / ${x.priceUnit}` : `${(x.estimatedPrice.retailPriceWithDiscount || x.estimatedPrice.retailPrice).toFixed(2)} €`,
      priceWithoutDiscount: x.priceUnit ? `${x.estimatedPrice.retailPrice.toFixed(2)} € / ${x.priceUnit}` : `${x.estimatedPrice.retailPrice.toFixed(2)} €`,
      discount: x.estimatedPrice.retailPriceDiscount?.value > 0 ? true : false,
      thumbnail: x.metadata.thumbnail,
      priceUnit: x.priceUnit
    }));

    this.items = productRes;
    this.mokriVidez = productRes.filter(x => x.attributes.vrsta_impregnacije === 'Mokri videz');
    this.brezbarvniVidez = productRes.filter(x => x.attributes.vrsta_impregnacije === 'Brezbarvni videz');
  }
}
